<template>
    <header class="ps-header" :class="className" v-if="!$isDing">
        <div class="left text">
            <a @click="back" id="headerBack" style="color:#8c8b8b;" class="icon iconfont " :class="hide && ' none'" :title="backMessage"></a>
        
        </div>
        <div class="center">
            <span>{{title || ""}}</span>
        </div>
        <div class="right text" @click="rightClickHandle">
          <slot name="rightIcon" ></slot>
        </div>
    </header>

</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    hide: Boolean,
    title: String,
		backMessage: String,
    className: String
  },
  methods: {
    // 返回
    back () {      
      this.$emit('back')
   
    },
    rightClickHandle(){
      this.$emit('rightClick')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/headers/Header.vue